import Router from '../router/index'
const $$ = {
  myBrowser() {
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    var isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
    var isIE = userAgent.indexOf("compatible") > -1
      && userAgent.indexOf("MSIE") > -1 && !isOpera; //判断是否IE浏览器
    var isEdge = userAgent.indexOf("Edge") > -1; //判断是否IE的Edge浏览器
    var isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器
    var isSafari = userAgent.indexOf("Safari") > -1
      && userAgent.indexOf("Chrome") == -1; //判断是否Safari浏览器
    var isChrome = userAgent.indexOf("Chrome") > -1
      && userAgent.indexOf("Safari") > -1; //判断Chrome浏览器
    if (isIE) {
      var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
      reIE.test(userAgent);
      var fIEVersion = parseFloat(RegExp["$1"]);
      if (fIEVersion == 7) {
        return "IE7";
      } else if (fIEVersion == 8) {
        return "IE8";
      } else if (fIEVersion == 9) {
        return "IE9";
      } else if (fIEVersion == 10) {
        return "IE10";
      } else if (fIEVersion == 11) {
        return "IE11";
      } else {
        return "0";
      }//IE版本过低
      return "IE";
    }
    if (isOpera) {
      return "Opera";
    }
    if (isEdge) {
      return "Edge";
    }
    if (isFF) {
      return "FF";
    }
    if (isSafari) {
      return "Safari";
    }
    if (isChrome) {
      return "Chrome";
    }
  },
  routerPush(name,query){
    Router.push({name: name,query: query})
  },
  formatDate(now) {
    now = new Date(now)
    let year = now.getFullYear();
    let month = now.getMonth() + 1;
    let date = now.getDate();
    let hour = now.getHours();
    let minute = now.getMinutes();
    let second = now.getSeconds();
    return year + "-"+month+"-"+date+" "+hour+":"+minute+":"+second;
  },
  showtime (time) {
    let nowtime = new Date();  //获取当前时间
    let endtime = new Date(time);  //定义结束时间
    let lefttime = endtime.getTime() - nowtime.getTime();  //距离结束时间的毫秒数
    let leftd = Math.floor(lefttime/(1000*60*60*24));  //计算天数
    let lefth = Math.floor(lefttime/(1000*60*60)%24);  //计算小时数
    let leftm = Math.floor(lefttime/(1000*60)%60);  //计算分钟数
    // let lefts = Math.floor(lefttime/1000%60);  //计算秒数
    leftd = leftd ? leftd+ "天" : '';
    return leftd + lefth + "小时" + leftm + "分钟";  //返回倒计时的字符串
  },
  orderState() {
    return { 10: '未付款', 20: '已付款', 30: '已发货' }
  },
  serviceType(){
    return { 1: '教师上门', 2: '学生上门' }
  },
  service(){
    return { release:'请名师',course: '名师课程'}
  },
  gender(){
    return  { 1: '男' ,2 : '女'}
  },
  glodsKeys(){
    return  { paper: '名师密卷' ,recharge : '充值'}
  },

}
export default $$



// WEBPACK FOOTER //
// ./src/utils/utils.js